"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactStyleClasses = _interopRequireDefault(require("react-style-classes"));
var _SubmenuModule = _interopRequireDefault(require("./Submenu.module.css"));
var _excluded = ["children", "position", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Submenu = function Submenu(_ref) {
  var children = _ref.children,
    position = _ref.position,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _reactStyleClasses.default)(_SubmenuModule.default.submenu, _SubmenuModule.default[position], className)
  }, props), /*#__PURE__*/_react.default.createElement("ul", null, children));
};
Submenu.propTypes = {
  children: _propTypes.default.node,
  position: _propTypes.default.oneOf(['left', 'right', 'bottom', 'left-top', 'right-top']),
  className: _propTypes.default.string
};
Submenu.defaultProps = {
  children: null,
  position: 'left',
  className: null
};
var _default = Submenu;
exports.default = _default;